import React, { useEffect, useState } from "react";
import ActivityBookingCard from "./ActivityBookingCard";
import { connect } from "react-redux";
import { popupOpenClose } from "../../../action/action";
import { withTranslation } from "react-i18next";
import { CMSPath } from "../../../config/constant";
import { formatTime } from "../spaBookingV2/spaBooking2a";
import { toBool } from "../../JS/utility";
import { DayPicker } from "react-day-picker";
import moment from "moment";
import { CalenderSvg } from "./WayActivity3";

const WayActivity4 = (props) => {
  const {goNextPage, goPreviousPage, availabilityApiResponse, currency, handleSelectedDataChange, selectedData, setSelectedParticipantCount, visibleTimeSlots, selectedParticipantCount, eventDetailedInfo, t} =  props;
  const [renderDatePicker, setRenderDatePicker ] = useState(false);

  const dateInputCss = `
    .rdp-day_selected {
        color: ${props.menuColor.assetFontSelectorColor};
        background-color: ${props.menuColor.assetBackgroundSelectorColor};
    }`;

  const onDateChange = (date) => {
    handleSelectedDataChange({date});
  }

  const handleProceed =()=>{
    if(!selectedData.date){
      props.popupOpenClose(true, t("way_activity.session_selection_page.validation.date"))
      return;
    }
    if(!selectedData.timeSlot){
      props.popupOpenClose(true, t("way_activity.session_selection_page.validation.time_slot"))
      return;
    }
    
    if(!selectedData.priceTiers || ( selectedData.priceTiers.length > 0 ? !Boolean(selectedData.priceTiers.reduce((acc, curr) => acc + curr.quantity , 0)) : false ) ){
      props.popupOpenClose(true, t("way_activity.session_selection_page.validation.price_tier"))
      return;
    }
    goNextPage();
  }

  const isDateDisabled = (date) => {
    console.log("date", moment(date).format("YYYY-MM-DD"), availabilityApiResponse )
    if( availabilityApiResponse.sessions.some(session =>{ return session.date == moment(date).format("YYYY-MM-DD")})){
      return false;
    }
    return true;
  }
  
  const onPackageQuantityUpdate = (id, change) => {
    console.log("inside onPackageQuantityUpdate..", id, change)
    const packages = [...selectedData.priceTiers];
    const updatedPackage = packages.map((p)=>{
      if(p.id != id) return p;

      return {...p, quantity: p.quantity + change};
    })
    handleSelectedDataChange({priceTiers: updatedPackage});

  };

  useEffect(()=>{
    if(selectedData.priceTiers){
      const participantCount = selectedData.priceTiers.reduce((acc, curr)=>acc + curr.quantity, 0) 
      setSelectedParticipantCount(participantCount)
    }else{
      setSelectedParticipantCount(null);
    }
  },[
    selectedData.priceTiers
  ])


  return (

    <>
    <header className="inner-pages w-footer subpages">
            <a className="button-back" onClick={goPreviousPage}></a>
            <div className="heading align-center">
            <div class="header">
                <p className="text">{t("way_activity.common.header_text")}</p>
              
            </div>
            </div>
    </header>
    <section id="activitiespage4" className="widgets container-bg activity-listing activity-sessions-listing">
      <section>

          <div class="widget-header-title">{selectedData.event.title}</div>
          <div class="widget-header-subtitle"  dangerouslySetInnerHTML={{__html:selectedData.event.description}} ></div>

      </section>

      <section className="container">
          <div className="activity-card-container">
            <div className="activity-booking-card" style={{ color: "black" }}>
              <div className="booking">



        <div className="date-picker">
            <div
              id="day-picker-input"
             
              onClick={()=>{  setRenderDatePicker(true)}}
            > 
            <CalenderSvg/>
            {selectedData.date ? moment(selectedData.date).format(props.dateFormat.toUpperCase()) : t("way_activity.common.view_by_date_placeholder") }
            </div>
          </div>

              

      {  selectedData.date &&  <>
      
         
                <div className="time-slots">
                  <div>
                    <div className="text-bold" >{t("way_activity.session_selection_page.time_slot_label")}</div>
                  </div>
                  <div className="time-slot-container">

                    {
                     visibleTimeSlots  && Object.entries(visibleTimeSlots).length > 0 ? 
                      (
                        Object.entries(visibleTimeSlots).map(([key, value]) =>{
                          console.log(key,value)
                            return (
                            <p
                              key={key}
                              className={`time-slot ${selectedData.timeSlot && ( key === (selectedData.timeSlot.startTime + selectedData.timeSlot.endTime )) ? "selected" : ""}`}
                              onClick={() => handleSelectedDataChange({timeSlot:{startTime: value[0].startTime , endTime: value[0].endTime }}) }
                            >
                              { formatTime(value[0].startTime,toBool(props.timeFormat)) + "-" +
                                formatTime(value[0].endTime,toBool(props.timeFormat))
                               }
                            </p>
                          )})
                        )
                      :
                      <div> {t("way_activity.common.no_sessions")} </div>             
                    
                    }
                  </div>
                </div>

      

                  { selectedData.priceTiers && <>      
                      {
                        <div className="pricetears-container pricetiers-container">
                        <div>
                          <div className="text-bold" >{t("way_activity.session_selection_page.price_tier_label")}</div>
                          <div className="remaining-stocks">{`${t("way_activity.session_selection_page.remaining_stocks")} ${selectedData.type.remainingStock - selectedParticipantCount }` }</div>
                        </div>
                          {
                            selectedData.type.remainingStock ?
                              selectedData.priceTiers.map((p, index) => (
                                                
                                              
                                <div className="row" key={p.id}>
                                  <div className="info">
                                    <p className="name">{p.name}</p>
                                    <p className="price">{`${currency} ${p.price}`}</p>
                                  </div>
                                  <div className="quantity-controls">
                                  
                                    <button disabled={selectedParticipantCount == 0 || p.quantity <= 0} className={`qty-btn minus ${(selectedParticipantCount == 0 || p.quantity <= 0 ) ? "disabled":""}`} onClick={() => onPackageQuantityUpdate(p.id, -1)} >
                                    
                                            <MinusSvg />
                                    
                                    </button>
                                    <p className="qty-value">{p.quantity}</p>
                                    <button disabled={selectedParticipantCount >= selectedData.type.remainingStock} className={`qty-btn plus ${(selectedParticipantCount >= selectedData.type.remainingStock ) ? "disabled":""}`}  onClick={() => onPackageQuantityUpdate(p.id, 1)} >
                                    
                                          <AddSvg />
                                      
                                    </button>
                                  </div>
                                </div>

                              )):
                            <>
                            <div>
                              {t("way_activity.session_selection_page.price_tier_not_available")}
                            </div >
                            </>
                          }
                        </div>
                      }
                   </>

                  }


                <div className="cancellation">
                  <div className="text-bold" >{t("way_activity.session_selection_page.cancellation_policy_title")}</div>
                  <p>{t("way_activity.session_selection_page.cancellation_policy_description")}</p>
                </div>

        </>  
      }          
              </div>
            </div>
          </div>

          <div class="row">
              <div class="form-controls">
                <button  
                className="continue"
                onClick={handleProceed}>
                    {t("way_activity.common.continue_button")}
                </button>
              </div>
            </div>
      </section>
    </section>

     { renderDatePicker &&
          <div className="overlay" onClick={(event) => { setRenderDatePicker(false);}}>
          <div class="overlay-date" onClick={(event) => { event.stopPropagation();}} >
              <style>{dateInputCss}</style>
              <DayPicker
                  mode="single"
                  timeZone="UTC"
                  selected={selectedData.date}
                  onSelect={(selectedDate) =>{ console.log(selectedDate); setRenderDatePicker(false); onDateChange(moment(selectedDate).format("YYYY-MM-DD")) }}
                  disabled={isDateDisabled}
              />
          </div>
        </div>
        }
    
    </>
  );
};

export function AddSvg(){
  return      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M8 3.33334V12.6667" stroke="#0C0A09" stroke-width="0.833333" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M3.33325 8H12.6666" stroke="#0C0A09" stroke-width="0.833333" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          
}

export function MinusSvg(){
  return     <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M3.33325 8H12.6666" stroke="#0C0A09" stroke-width="0.833333" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
         
}
const mapStateToProps= (state)=>{
  return {
    timeFormat:
    state.store.home.clientConfig.extraConfigParam &&
    state.store.home.clientConfig.extraConfigParam.TIME_FORMAT_MERIDIEM,
    installedAppVersion: state.store.installedAppVersion,
    installedAppBuildNo: state.store.installedAppBuildNo,
    currentHomePage: state.store2.currentHomePage,
    currentWidgetObj: state.store.sideNavBar.currentWidget,
    guestDetail: state.store.home.guestDetails,
    guestIsLoggedIn: state.store2.guestIsLoggedIn,
    currentWidgets: state.store.sideNavBar.currentWidget,
    dateFormat: state.store.home.clientConfig.extraConfigParam
      ? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT
      : "",
    // timeFormat: state.store.home.clientConfig.extraConfigParam.TIME_FORMAT_MERIDIEM,
    serverTimeDate: state.store.home.serverTimeDate.date,
    serverDate: state.store.home.serverTimeDate,
    menuColor: state.store.home.MenuColor,
  }
}

const mapDispatchToProps = {
  popupOpenClose
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation("translations")(WayActivity4));








// <div className="select-users-container">
// <label htmlFor="people">Select how many people will be joining:</label>
// <div className="select-box">
//   <svg
//     xmlns="http://www.w3.org/2000/svg"
//     width="16"
//     height="16"
//     viewBox="0 0 16 16"
//     fill="none"
//   >
//     <path
//       d="M7.99976 1.37671C9.89026 1.37671 11.4233 2.90912 11.4236 4.79956C11.4236 6.35985 10.3785 7.67767 8.94995 8.0896L9.01929 8.95581C10.2207 9.10222 11.2139 9.5216 11.9509 10.2478C12.8867 11.1701 13.3962 12.5758 13.3962 14.5066C13.3962 14.5414 13.3684 14.5699 13.3337 14.5701H13.3328C13.2979 14.5698 13.2703 14.5415 13.2703 14.5066C13.2703 12.7166 12.827 11.4028 12.0271 10.5115L11.8621 10.3386L11.6882 10.1765C10.7927 9.39568 9.54042 9.02319 7.99976 9.02319C6.35648 9.02321 5.04156 9.4476 4.13745 10.3386C3.23364 11.2295 2.73022 12.5972 2.73022 14.5066C2.73022 14.5415 2.70169 14.57 2.66675 14.5701C2.63174 14.5701 2.60328 14.5416 2.60327 14.5066C2.60327 12.5758 3.11277 11.1701 4.04858 10.2478C4.78561 9.52151 5.77873 9.10222 6.98022 8.95581L7.04956 8.0896C5.62095 7.67766 4.5769 6.35984 4.5769 4.79956C4.57715 2.90916 6.10932 1.37678 7.99976 1.37671ZM7.99976 1.50366C6.17927 1.50374 4.70313 2.97912 4.70288 4.79956C4.70288 6.62021 6.17912 8.09636 7.99976 8.09644C9.82045 8.09644 11.2966 6.62026 11.2966 4.79956C11.2964 2.97907 9.8203 1.50366 7.99976 1.50366Z"
//       fill="#0C0A09"
//       stroke="#0C0A09"
//       strokeWidth="0.886667"
//     />
//   </svg>

//   <select id="people" value={selectedParticipantCount} onChange={(e)=>{setSelectedParticipantCount(Number(e.target.value))}}>
//     <option value="">
//       Select
//     </option>
//   {
//     availabilityApiResponse && availabilityApiResponse.data && availabilityApiResponse.data.supportedParticipantsCount ?
//     [...Array(availabilityApiResponse.data.supportedParticipantsCount)].map((_,index)=>
//       <option value={index+1}>{index+1}</option>
//     )
//     :<>
//     <option value={1}>1</option>
//     </>

//   }
//   </select>
// </div>
// </div>



// const getAvailablePackages = ()=>{
//   const _packageInfo = availabilityApiResponse.data;
  
//   if (!_packageInfo || !_packageInfo.priceTiers || !_packageInfo.availableQuantityPerTier ) {
//     return [];
//   };


//   const formattedPackageInfo = _packageInfo.priceTiers.map(tier => ({
//       ...tier,
//       maxQuantity: _packageInfo.availableQuantityPerTier[tier.name],
//       quantity: 0
//      })
//   );

//   return formattedPackageInfo;

// } 

// const getAvailableSessions = () => {
//   const _sessionInfo = availabilityApiResponse.sessions;

//   if (! _sessionInfo ) {
//     return []; 
//   }
   
//   return _sessionInfo;
// };
